var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs",class:[("of-" + (_vm.slots.length)), _vm.isActive ? 'active' : null]},[_c('tabs-head',{attrs:{"tabs":_vm.slots,"active":_vm.activeTab},on:{"update:active":_vm.set}}),_c('div',{staticClass:"body"},_vm._l((_vm.slots),function(name){return _c('div',{key:name},[(_vm.activeTab === name)?_vm._t(name):_vm._e()],2)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca26e59","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/globals/Tabs.vue
// module id = 418
// module chunks = 8